import {
  AI_DETECTOR_SLUG,
  PARAPHRASING_TOOL_SLUG,
  PLAGIARISM_CHECKER_SLUG,
  GRAMMAR_CHECK_SLUG,
  AI_HUMANIZER_SLUG,
} from '@lib/constants'
import { StatsigExperiments } from '@lib/services/experiments/experiments'

/**
 * Map of pageSlugs and the names of the experiments we want GA4 tracking for on those pages.
 * We can track both client side and server-side experiments.
 * NOTE: We are only able to track one experiment per page right now - https://grammarly.atlassian.net/browse/G2A-1980.
 */
const pageSlugToExpToTrackMap = new Map<string, string>()
const topFiveToolSlugs = [
  AI_DETECTOR_SLUG,
  PARAPHRASING_TOOL_SLUG,
  PLAGIARISM_CHECKER_SLUG,
  GRAMMAR_CHECK_SLUG,
  AI_HUMANIZER_SLUG,
]
topFiveToolSlugs.forEach((toolSlug) => {
  pageSlugToExpToTrackMap.set(toolSlug, StatsigExperiments.ToolsRedesign2_X.name)
})

export { pageSlugToExpToTrackMap }
